<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-15 11:29:13
 * @Description: 游客投诉处置满意度
-->
<template>
  <div class="container">
    <!-- header -->
    <div class="head">
      <div class="title">
        <div class="text">{{ assessName }}</div>
        <div class="flex-row f-s-s mt-8">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>
      </div>
      <div class="rules">
        <div v-if="Number(deduction) == 0" class="no-de">未扣分</div>
        <div v-else class="branch">-{{ deduction }}</div>
        <div class="num">{{ score }}/{{ totalScore }}</div>
      </div>
    </div>
    <!-- 考评信息  -->
    <div class="mx-12">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        考评信息
      </div>
      <div class="card-bg ">
        <div class="flex-col px-12 py-12">
          <div class="" v-if="result">
            {{ result?.donetimeAvg | deductionReason(deduction) }}
          </div>
          <div class="" v-else>不扣分</div>
        </div>
      </div>

    </div>

    <!-- 投诉情况  -->
    <div class="mx-12" v-if="result">
      <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
        投诉情况
      </div>
      <div class="card-bg py-24">
        <div class="flex flex-row">
          <!--  -->
          <div class="border-0 border-r-[1px] border-solid border-r-[#EEEEEE] px-24 flex-1 flex flex-col items-center justify-center">
            <div class="text-12 text-[#333333] line-clamp-1">投诉数量</div>
            <div class="mt-8  text-center">
              <span class="text-[#36B374] text-32 font-bold">{{ result?.complainNum }}</span>
              <span class="text-[#36B374] text-10 font-400 align-text-bottom">件</span>
            </div>
          </div>
          <!--  -->
          <div class="px-12 flex-1 flex flex-col items-center justify-start">
            <div class="text-12 text-[#333333] line-clamp-1 ">平均办结时长</div>
            <div class="mt-14 ">
              <span class="text-[#36B374] text-20 font-bold">{{ result?.donetimeAvgCN ? result.donetimeAvgCN :"-" }}</span>
              <!-- <span class="text-[#36B374] text-10 font-400 align-text-bottom">件</span> -->
            </div>
          </div>

        </div>

      </div>
    </div>


    <!-- 没有扣分记录提示 -->
    <div class="noData-bg" v-if="!result">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nodata from "../components/nodata"; // 没有数据
import deducList from "./components/deducList"; // 扣分列表

import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import { type } from "@/utils/configJson";

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    nodata,
    deducList,
  },
  name: 'touristComplainHandleSatisfaction',
  props: {

  },
  data() {
    // 这里存放数据
    return {
      assessName: this.$route.query.assessName,
      noData: {
        title: "暂无数据",
      },
      asscessType: this.$route.query.asscessType,
      deduction: this.$route.query.deduction,
      score: this.$route.query.score,
      totalScore: this.$route.query.totalScore,

      quarterName: this.$route.query.quarterName,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      area: this.$route.query.area,
      areaName: this.$route.query.areaName,
      result: null,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  filters: {
    deductionReason(donetimeAvg,deduction) {
      if(isNaN(donetimeAvg)) return ''
      let avgMinute = (Number(donetimeAvg) / 60 ).toFixed(1)
      if (avgMinute == 0) return '未扣分'
      // 
      const hourThresholds = [9, 8, 7, 6, 5, 4];
      let timeHour = hourThresholds.find(hour => avgMinute >= hour * 60) || 3;
      if (timeHour >= 4){
        return '扣分原因：平均响应时长超过'+timeHour+'小时，扣' + deduction +'分'
      }else{
        return '未扣分'
      }
      
      
    }
  },
  // 方法集合
  methods: {
    getdeductionList(year, quarter, area) {
      API.findAllComplainDoneRate({ year, quarter, area }).then((res) => {
        console.log("-----列表:", res);
        if (res.ret == 0 && res.data && res.data.all && res.data.all.length > 0) {
          this.result = res.data.all.find(item => item.area == this.area)
          // 州市角色查看时 返回值在这里
        } else if(res.ret == 0 && res.data && res.data.oneAreaTypeResVO && res.data.oneAreaTypeResVO.length > 0){
          this.result = res.data.oneAreaTypeResVO.find(item => item.area == this.area)
        } else if(res.ret == 0 && res.data && res.data.twoAreaTypeResVO && res.data.twoAreaTypeResVO.length > 0){
          this.result = res.data.twoAreaTypeResVO.find(item => item.area == this.area)
        }

      });
    },


  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log('output->[ created ] >', this.$route.query)
    this.getdeductionList(this.year, this.quarter, this.area)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//  @import url(); 引入公共css类
.card-bg {
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;

}


.container {
  min-height: 100vh;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  position: relative;

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
  }

  .head {
    background: #fff;
    padding: 20px 12px;
    display: flex;
    justify-content: space-between;

    .title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 50px;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }

      .tit {
        position: relative;
        display: flex;
        color: #999;
        font-size: 12px;
        margin-top: 12px;

        span {
          position: relative;
          padding-right: 16px;
        }

        span::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 12px;
          height: 12px;
          background: url(../../../assets/image/t-right.png) no-repeat;
          background-size: 12px 12px;
        }
      }
    }

    .rules {
      display: flex;
      flex-direction: column;
      color: #666666;
      text-align: right;

      .num {
        color: #999999;
        font-size: 14px;
        margin-top: 8px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        // font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }

      .no-de {
        min-width: 60px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #999;
        line-height: 22px;
      }
    }
  }
}
</style>